const config = {
    API_PREFIX: process.env.REACT_APP_DEV === "true" ? "https://admin.fullstack.courses/api/v1/" : "https://admin.fullstack.courses/api/v1/",
    API_GAME: process.env.REACT_APP_DEV === "true" ? "https://admin.fullstack.courses/api/v2/" : "https://admin.fullstack.courses/api/v2/",
    VIDEO_PREFIX: "https://fullstack.courses/api/v1/video/",
    SOCKET_URL: "https://fullstack.courses",
    MAIN_URL: process.env.REACT_APP_DEV === "true" ? "https://dev.educat.courses" : "https://educat.courses"
};

export default config;
